import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class SecuenceService {

    //VARIABLES
    URI_SECUENCE = 'https://foxylabs-eventos.herokuapp.com/api/secuencias';
   
    
    constructor(private http: HttpClient) {

    }

    get_all(){
        return this.http.get<any>(`${this.URI_SECUENCE}/get_all`).pipe(map(data => {
            return data;
        }));    
    }

    get_secuence_by_id(id_secuence:number){
        return this.http.get<any>(`${this.URI_SECUENCE}/get_${id_secuence}`).pipe(map(data => {
            return data;
        }));    
    }
   
    post(data:any) {
        
        var headers = new HttpHeaders({'Content-Type': 'application/json' });        
        return this.http.post(`${this.URI_SECUENCE}/add`, data, { headers }).pipe(map(res => {
            return res;
        }));
    }

    



}